import UploadIcon from './UploadIcon';

export default UploadIcon;
